var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 4.12012C14.2978 4.12012 13.8501 3.6724 13.8501 3.12012C13.8501 2.56783 14.2978 2.12012 14.8501 2.12012L20.8501 2.12012C20.8928 2.12012 20.9349 2.1228 20.9763 2.128C21.4908 2.16912 21.8955 2.59969 21.8955 3.12479V9.12479C21.8955 9.67707 21.4478 10.1248 20.8955 10.1248C20.3432 10.1248 19.8955 9.67707 19.8955 9.12479V5.51978L8.82068 16.1764C8.42271 16.5593 7.78967 16.5472 7.40673 16.1492C7.02379 15.7512 7.03597 15.1182 7.43394 14.7352L18.4656 4.12012L14.8501 4.12012Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1001 6.87012C4.1001 6.31783 4.54781 5.87012 5.1001 5.87012H11.6334C12.1857 5.87012 12.6334 5.4224 12.6334 4.87012C12.6334 4.31783 12.1857 3.87012 11.6334 3.87012H5.1001C3.44324 3.87012 2.1001 5.21326 2.1001 6.87012V18.8701C2.1001 20.527 3.44324 21.8701 5.1001 21.8701H17.1001C18.757 21.8701 20.1001 20.527 20.1001 18.8701V12.3368C20.1001 11.7845 19.6524 11.3368 19.1001 11.3368C18.5478 11.3368 18.1001 11.7845 18.1001 12.3368V18.8701C18.1001 19.4224 17.6524 19.8701 17.1001 19.8701H5.1001C4.54781 19.8701 4.1001 19.4224 4.1001 18.8701V6.87012Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkX2);
export default __webpack_public_path__ + "static/media/ExternalLinkX2.8c6bfbd9b3d786286cf2169b6ee34e8d.svg";
export { ForwardRef as ReactComponent };